import axios from 'axios';

let IpInfo = {

	fetchCountryCode: function() {
		
		let promise = axios.get('https://ipinfo.io/json')
   	.then(response => { 
   		return response.data.country; 
   	})
   	.catch((error) => {
   		return undefined;
   	});

   	return promise;

	}

}

module.exports = IpInfo;


// WEBPACK FOOTER //
// ./src/js/services/ipinfo.js